import { Item } from "../../../../../pojo/Item";
import { S25Const } from "../../../../../util/s25-const";
import {
    DASH_DITEM_EDIT_TYPE_IDS,
    DASH_DITEM_FAVORITE_TYPE_IDS,
    DASH_DITEM_ROW_ICON_TYPE,
    DASH_LIST_S25_ITEM_TYPE_NAMES,
    dashDitemRowIconType,
} from "./home.dash.panel.list.ditem.const";
import { DashPanelListItemBean } from "./home.dash.panel.list.item.types";

export { DashDitemTypeId, dashDitemRowIconType } from "./home.dash.panel.list.ditem.const";

export function normalizeDashPanelListItem(item: DashPanelListItemBean, panelTypeId: number): DashPanelListItemBean {
    return {
        ...item,
        itemTypeId: item.itemTypeId ?? panelTypeId,
        itemType: item.itemType ?? S25Const.itemType[item.itemTypeId ?? panelTypeId]?.type,
    };
}

export function dashListItemShowsFavorite(ditemTypeId: number | undefined): boolean {
    return ditemTypeId !== undefined && DASH_DITEM_FAVORITE_TYPE_IDS.has(ditemTypeId);
}

export function dashListItemShowsEdit(ditemTypeId: number | undefined, item: DashPanelListItemBean): boolean {
    return ditemTypeId !== undefined && DASH_DITEM_EDIT_TYPE_IDS.has(ditemTypeId) && !item.noSchedulePerm;
}

export function dashListItemShowsTypeIcon(ditemTypeId: number | undefined): boolean {
    return ditemTypeId !== undefined && ditemTypeId in DASH_DITEM_ROW_ICON_TYPE;
}

export function dashListItemIsFavorited(item: DashPanelListItemBean): boolean {
    return !item.isUnstar;
}

/**
 * Canonical {@link Item.Ids} for dash list rows that should use `<s25-item>`.
 * Starred events/locations/resources use dash type ids 11/14/16; s25-item tooltips and menus
 * require Event/Location/Resource (1/4/6).
 */
export function dashListItemObjectTypeId(
    ditemTypeId: number | undefined,
    itemId: number | undefined,
): Item.Ids | undefined {
    if (!itemId || !Number.isFinite(itemId) || ditemTypeId === undefined) {
        return undefined;
    }
    const typeName = S25Const.itemType[ditemTypeId]?.type as string | undefined;
    if (!typeName || !DASH_LIST_S25_ITEM_TYPE_NAMES.has(typeName)) {
        return undefined;
    }
    return S25Const.itemName2Id[typeName] as Item.Ids;
}
